import Emoji, { emojis } from "@tiptap/extension-emoji";
import History from "@tiptap/extension-history";
import Mention from "@tiptap/extension-mention";
import Youtube from "@tiptap/extension-youtube";
import {
  BlockquoteFigure,
  CodeBlock,
  Color,
  Column,
  Columns,
  Details,
  DetailsContent,
  DetailsSummary,
  Document,
  Dropcursor,
  Figcaption,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  HorizontalRule,
  ImageBlock,
  Link,
  Placeholder,
  StarterKit,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  TaskItem,
  TaskList,
  TextAlign,
  TextStyle,
  TrailingNode,
  Typography,
  Underline,
  UniqueID,
} from ".";
import { ServerVariableNode } from "../../../Helper/VariableExtension";
import { ButtonExtension } from "./custom/Button/ButtonExtension";
import { Callout } from "./custom/Callout/TipTapCallout";
import { HelpcenterLinkExtension } from "./custom/HelpCenterLink/HelpCenterLinkExtension";
import HidePlaceholderExtension from "./custom/HidePlaceholder/HidePlaceholder";
import iFrame from "./custom/iFrame/iFrame";
import { CustomImageExtension } from "./custom/Image/CustomImageExtension";

const emojisWithoutFallbackImages = emojis.map((emoji) => ({
  ...emoji,
  fallbackImage: undefined,
}));

export const ExtensionKit = () => [
  Document,
  Columns,
  TaskList,
  TaskItem.configure({
    nested: true,
  }),
  Column,
  Heading.configure({
    levels: [1, 2, 3, 4, 5, 6],
  }),
  HorizontalRule,
  UniqueID.configure({
    types: ["paragraph", "heading", "blockquote", "codeBlock", "table"],
  }),
  StarterKit.configure({
    document: false,
    dropcursor: false,
    heading: false,
    horizontalRule: false,
    blockquote: {},
    codeBlock: false,
    trailingNode: false,
    link: false,
    underline: false,
    undoRedo: false,
  }),
  Details.configure({
    persist: true,
    HTMLAttributes: {
      class: "details",
    },
  }),
  Emoji.configure({ emojis: emojisWithoutFallbackImages }),
  DetailsContent,
  DetailsSummary,
  CodeBlock,
  TextStyle,
  FontSize,
  FontFamily,
  Color,
  TrailingNode,
  Link.configure({
    openOnClick: false,
    protocols: ["gleap"],
  }),
  Highlight.configure({ multicolor: true }),
  Underline,
  CustomImageExtension,
  ImageBlock,
  TextAlign.extend({
    addKeyboardShortcuts() {
      return {};
    },
  }).configure({
    types: ["heading", "paragraph"],
  }),
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Typography,
  Placeholder.configure({
    includeChildren: true,
    showOnlyCurrent: false,
    placeholder: () => "",
  }),
  Figcaption,
  BlockquoteFigure,
  Dropcursor.configure({
    width: 2,
    class: "ProseMirror-dropcursor border-black",
  }),
  Callout,
  iFrame,
  ButtonExtension,
  Youtube.configure({ HTMLAttributes: { class: "youtube-video" } }),
  HelpcenterLinkExtension,
  Mention,
  History,
  ServerVariableNode,
  HidePlaceholderExtension("iframePlaceholder"),
  HidePlaceholderExtension("youtubePlaceholder"),
  HidePlaceholderExtension("imageUploadPlaceholder"),
  HidePlaceholderExtension("imageUpload"),
  HidePlaceholderExtension("imageSkeleton"),
];

export default ExtensionKit;
